import { useMemo } from "react";

export const OrderItemsTable = ({ order }) => {
  const extraDispatchRows = useMemo(
    () => (order.dispatch_items || []).filter((di) => !order.items.some((it) => it.product_name === di.product_name)),
    [order]
  );

  return (
    <div className="rounded-md border border-slate-200 bg-white">
      <h2 className="border-b border-slate-200 p-4 text-base font-bold text-slate-900 md:text-lg">Line Items</h2>
      <table className="w-full text-sm">
        <thead>
          <tr className="border-b border-slate-200 bg-slate-50 text-left text-xs font-semibold uppercase tracking-wider text-slate-500">
            <th className="p-3">Product</th>
            <th className="p-3 text-right">Qty</th>
            {order.dispatch_items && <th className="p-3 text-right">Dispatched</th>}
          </tr>
        </thead>
        <tbody>
          {order.items.map((it, i) => (
            <tr key={`${it.product_name}-${i}`} className="border-b border-slate-100">
              <td className="p-3 font-medium">{it.product_name}</td>
              <td className="p-3 text-right font-mono">{it.quantity}</td>
              {order.dispatch_items && (
                <td className="p-3 text-right font-mono">
                  {order.dispatch_items.find((di) => di.product_name === it.product_name)?.quantity ?? "—"}
                </td>
              )}
            </tr>
          ))}
          {extraDispatchRows.map((di) => (
            <tr key={`d-${di.product_name}`} className="border-b border-slate-100">
              <td className="p-3 font-medium">
                {di.product_name} <span className="text-xs text-amber-600">(added at dispatch)</span>
              </td>
              <td className="p-3 text-right font-mono">—</td>
              <td className="p-3 text-right font-mono">{di.quantity}</td>
            </tr>
          ))}
          <tr className="bg-slate-50 font-semibold">
            <td className="p-3">Total</td>
            <td className="p-3 text-right font-mono" data-testid="order-detail-total-qty">{order.total_quantity}</td>
            {order.dispatch_items && (
              <td className="p-3 text-right font-mono" data-testid="order-detail-dispatched-qty">{order.dispatched_quantity}</td>
            )}
          </tr>
        </tbody>
      </table>
      {order.notes && <p className="border-t border-slate-100 p-4 text-sm text-slate-500">Notes: {order.notes}</p>}
    </div>
  );
};
